<script>
import firebase from '@firebase/app'
import { Pie } from 'vue-chartjs'

export default {
    extends: Pie,
    data () {
        return {
            chartdata: {
                labels: ['喜', '怒','哀', '楽'],
                datasets: [{
                    backgroundColor: [
                        '#FE7E00',
                        '#D53E4F',
                        '#3288BD',
                        '#FEFF99',
                    ],
                    data: [0,0,0,0]
                }],
            },
            options: {
                title: {
                    display: true,
                },
                responsive: true,
                maintainAspectRatio: false,
            }
        }
    },
    computed:{
        user(){
            return this.$store.getters.user;
        }
    },
    created(){
        var [ , , year_path, month_path] = location.pathname.split('/')
        firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).get().then(snapshot => {
            snapshot.forEach(doc => {
                var data = doc.data()
                var pie = data.emotionData
                for(var key in pie){
                    if(pie[key].Emotion ==  "喜"
                    || pie[key].Emotion ==  "驚"
                    || pie[key].Emotion ==  "感"
                    || pie[key].Emotion ==  "動"
                    || pie[key].Emotion ==  "祝"
                    || pie[key].Emotion ==  "興"
                    ){
                        var array_0 =  this.chartdata.datasets[0].data[0] + 1;
                        this.chartdata.datasets[0].data.splice(0, 1, array_0)
                    }
                    if(pie[key].Emotion ==  "怒"
                    || pie[key].Emotion ==  "恨"
                    || pie[key].Emotion ==  "悔"
                    || pie[key].Emotion ==  "F"
                    || pie[key].Emotion ==  "憎"
                    || pie[key].Emotion ==  "嫌"
                    || pie[key].Emotion ==  "不"
                    || pie[key].Emotion ==  "苦"
                    || pie[key].Emotion ==  "恥"
                    || pie[key].Emotion ==  "困"
                    || pie[key].Emotion ==  "き"
                    || pie[key].Emotion ==  "失"
                    || pie[key].Emotion ==  "見"
                    || pie[key].Emotion ==  "怠"
                    || pie[key].Emotion ==  "あ"
                    || pie[key].Emotion ==  "妬"
                    ){
                        var array_1 =  this.chartdata.datasets[0].data[1] + 1;
                        this.chartdata.datasets[0].data.splice(1, 1, array_1)
                    }
                    if(pie[key].Emotion ==  "哀"
                    || pie[key].Emotion ==  "悲"
                    || pie[key].Emotion ==  "寂"
                    || pie[key].Emotion ==  "切"
                    || pie[key].Emotion ==  "辛"
                    || pie[key].Emotion ==  "悩"
                    || pie[key].Emotion ==  "憐"
                    || pie[key].Emotion ==  "謝"
                    || pie[key].Emotion ==  "残"
                    || pie[key].Emotion ==  "情"
                    || pie[key].Emotion ==  "怖" 
                    || pie[key].Emotion ==  "不鬱"
                    || pie[key].Emotion ==  "ふ"
                    || pie[key].Emotion ==  "心"
                    || pie[key].Emotion ==  "鬱"
                    || pie[key].Emotion ==  "焦"
                    || pie[key].Emotion ==  "恐"
                    || pie[key].Emotion ==  "た"
                    || pie[key].Emotion ==  "心"
                    || pie[key].Emotion ==  "緊"
                    ){
                        var array_2 =  this.chartdata.datasets[0].data[2] + 1;
                        this.chartdata.datasets[0].data.splice(2, 1, array_2)
                    }
                    if(pie[key].Emotion ==  "楽"
                    || pie[key].Emotion ==  "気"
                    || pie[key].Emotion ==  "安"
                    || pie[key].Emotion ==  "穏"
                    || pie[key].Emotion ==  "親"
                    || pie[key].Emotion ==  "好"
                    || pie[key].Emotion ==  "尊"
                    || pie[key].Emotion ==  "誇"
                    || pie[key].Emotion ==  "幸"
                    || pie[key].Emotion ==  "願"
                    ){
                        var array_3 =  this.chartdata.datasets[0].data[3] + 1;
                        this.chartdata.datasets[0].data.splice(3, 1, array_3)
                    }
                }
            })
        }).then(()=>{
            this.renderChart(this.chartdata, this.options)
        });
    }
}
</script>